import React from 'react';

function CompanyManagement(props) {
    return (
        <div></div>
    );
}

export default CompanyManagement;